import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a51dc500&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51dc500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a51dc500')) {
      api.createRecord('a51dc500', component.options)
    } else {
      api.reload('a51dc500', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a51dc500&scoped=true", function () {
      api.rerender('a51dc500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pickup-address/index.vue"
export default component.exports